import React from "react";
import { useDispatch } from 'react-redux';
import { removeDocumentFile } from '../actions';
import { DEFAULT_DOCUMENT, DEFAULT_INDEX } from '../constants';

import { BsCaretLeftFill } from 'react-icons/bs';
import { MdDelete } from 'react-icons/md';
import { setFocusShareDocument } from '..';
import documentLoading from '../../../assets/images/dsLoading.gif';
import ImageThumb from './ImageThumb';

export function LoadingProgress() {
    return (
        <div className='document_loading'>
            <p style={{
                background: `url(${documentLoading}) no-repeat`,
                display: 'inlineBlock',
                width: '141px',
                height: '24px',
                transform: 'scale(0.5)',
            }}></p>
            <span>등록중</span>
        </div>
    )
}

export default function DocumentItem({
    t, shareDocumentPermission, item, depthItem, setOnDepthItem
}) {
    const dispatch = useDispatch();

    const onFocusDocument = (index, numPages) => {
        if (depthItem || numPages === 1) {
            if (!shareDocumentPermission) return;
            dispatch(setFocusShareDocument(item.uuid, index, false, false));
        } else setOnDepthItem(item.uuid);
    }

    return (
        <>
            { (shareDocumentPermission || (!shareDocumentPermission && item.shared)) && 
                <div className={`item_${!depthItem || depthItem === item.uuid ? 'open' : 'hide'} item_${item.uuid}`}>
                    <ShareDocumentLabel t={t}
                        shareDocumentPermission={shareDocumentPermission}
                        item={item} uuid={item.uuid} prevDepth={depthItem === false ? true : false}
                        setOnDepthItem={setOnDepthItem}
                    />
                    { !item.isWhiteBoard && 
                        <>
                            { item.complete ? 
                                <ImageThumb item={item} depthItem={depthItem} onFocusDocument={onFocusDocument} /> 
                                : <LoadingProgress /> }
                        </>
                    }
            </div>}
        </>
    );
}

export function ShareDocumentLabel({
    t, item, uuid, prevDepth, setOnDepthItem, shareDocumentPermission
}) {
    const dispatch = useDispatch();

    const onDeleteDocument = () => {
        dispatch(removeDocumentFile(item.uuid, item.isWhiteBoard));
        setOnDepthItem(false);

        APP.mateManagement.deleteShareDocument(item.uuid);
    };

    const onClick = () => {
        if (item.isWhiteBoard) {
            setOnDepthItem(item);
        } else {
            setOnDepthItem(false);
        }
    }
    const focusOn = () => {
        if (item.isWhiteBoard) {
            dispatch(setFocusShareDocument(item.uuid, DEFAULT_INDEX, true, false));
        }
    }

    return (
        <>
            <div className={`name ${uuid} ${item.isWhiteBoard ? 'hover': ''}`} onClick={focusOn}> 
                { prevDepth && item.uuid !== DEFAULT_DOCUMENT && shareDocumentPermission && <MdDelete size={20} onClick={onDeleteDocument} /> }
                { !item.isWhiteBoard && !prevDepth && <BsCaretLeftFill size={20} onClick={onClick}/> }
                <span className='text nonSelect' >
                    { item.isWhiteBoard && t('document.whiteBoard') } { item.file.name } 
                </span>
                { shareDocumentPermission && item.shared && <span className="status_label"></span>}
            </div>
        </>
    )
}